module.exports = "/_next/static/images/jasmy-2eb9c84b4f781e7c1d7ba26a3bfa9205.svg";